import { render, staticRenderFns } from "./DropdownBubble.vue?vue&type=template&id=185db1a8&scoped=true"
import script from "./DropdownBubble.vue?vue&type=script&lang=js"
export * from "./DropdownBubble.vue?vue&type=script&lang=js"
import style0 from "./DropdownBubble.vue?vue&type=style&index=0&id=185db1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185db1a8",
  null
  
)

export default component.exports